import { FormikProps } from 'formik'
import * as React from 'react'
import TextField from '../ui/TextField'
import { IVehicleMake } from 'src/types'
import GenericDropdown from '../ui/GenericDropdown'

interface IServiceProgramFormProps {
  formikProps: FormikProps<any>
  labelTitle: string
  children: React.ReactNode
  makeList?: IVehicleMake[]
}

const SettingForm = (props: IServiceProgramFormProps) => {
  const makes: Array<{
    label: string
    value: any
  }> = []
  if (props.makeList) {
    for (const i of Object.keys(props.makeList)) {
      makes.push({
        label: props.makeList[i].name,
        value: props.makeList[i].id
      })
    }
  }
  return (
    <form onSubmit={props.formikProps.handleSubmit}>
      <div className='mb1'>
        <TextField
          title={props.labelTitle}
          name={'label'}
          optional={false}
          error={props.formikProps.errors.label}
          classNameContainer={'mr1'}
          touched={props.formikProps.touched.label}
          onChange={props.formikProps.handleChange}
          value={props.formikProps.values.label}
          className='mt1 p1 border-light-grey4 rounded h5'
          placeholder={props.labelTitle}
        />
      </div>
      <div className='mb3'>
        <div className='h6 mb1'>Make</div>
        <GenericDropdown name={'make'} options={makes} defaultOption={makes[0]} placeholder='Make' />
      </div>
      {props.children}
    </form>
  )
}

export default SettingForm



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingModelForm.tsx